import { Injectable } from '@angular/core';

import {BehaviorSubject, firstValueFrom} from 'rxjs';
import { first, map } from 'rxjs/operators';

import { AllowedOperation, ClassName, Role } from '@sim/role/models/role';
import { RoleApiService } from '@sim/role/services/role-api.service';
import { checkIsAllow, isUserAdmin } from '@sim/role/utils';

@Injectable({
  providedIn: 'root',
})
export class RoleService {

  /** Role of the logged user */
  private readonly roleContainer$ = new BehaviorSubject<Role | undefined>(undefined);

  get role$() {
    return this.roleContainer$.asObservable();
  }

  get role() {
    return this.roleContainer$.value;
  }

  constructor(
    private readonly roleApi: RoleApiService,
  ) {
  }

  async setRoleById(roleId: string | undefined) {
    if (roleId) {
      const role = await firstValueFrom(this.roleApi.get(roleId).pipe(first()));
      this.roleContainer$.next(role);
    } else {
      this.roleContainer$.next(undefined);
    }
  }

  hasCapability(className?: ClassName, allowedOperations?: AllowedOperation) {
    if (this.role) {
      return checkIsAllow(this.role, allowedOperations as AllowedOperation, className);
    } else {
      return false;
    }
  }

  isAdmin() {
    return this.role$.pipe(map((role) => role ? isUserAdmin(role) : false));
  }
}
